module.exports = __webpack_public_path__ + "static/media/user-male.08e6ccaf.png";